import React from "react";
const IconDrag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      d="M7.75 4.5 2.25 10l5.5 5.5M12.25 4.5l5.5 5.5-5.5 5.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconDrag;
